import { ReactNotificationOptions, store } from 'react-notifications-component';

import { ApiError } from '@api/client/errors';

const notyDefaultConfig: ReactNotificationOptions = {
    insert: 'top',
    container: 'top-right',
    dismiss: {
        duration: 4250,
        onScreen: false,
        pauseOnHover: true,
        showIcon: true,
    },
    animationIn: ['notification__item--fadeIn'],
    animationOut: ['notification__item--fadeOut'],
};

type ApiErrorCallback = (apiError: ApiError) => void;

export const SnackBar = {
    success(message: string, title = 'Успешно'): void {
        SnackBar.showNotification({ title, message, type: 'success' } as ReactNotificationOptions);
    },

    warning(message: string, title = 'Предупреждение'): void {
        SnackBar.showNotification({ title, message, type: 'warning' } as ReactNotificationOptions);
    },

    danger(message: string, title = 'Ошибка'): void {
        SnackBar.showNotification({ title, message, type: 'danger' } as ReactNotificationOptions);
    },

    showNotification(options: ReactNotificationOptions): void {
        store.addNotification({
            ...notyDefaultConfig,
            ...options,
        });
    },

    handleApiError(error: unknown, callback: ApiErrorCallback = () => {}): void {
        // TODO handle other error types
        if (!(error instanceof ApiError)) return;
        const commonErrorMessage = error.getCommonFirstMessage();
        if (commonErrorMessage) {
            SnackBar.danger(commonErrorMessage);
        } else {
            const invalidFirstFieldMessage = error.getInvalidFirstMessage();
            if (invalidFirstFieldMessage) SnackBar.danger(invalidFirstFieldMessage);
        }

        callback(error);
    },
};
